export default __webpack_public_path__ + "static/media/LB.5ebe7675.svg";